/**
 * @flow
 * @relayHash 932618177e04df34a3e79ee0928f096d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GameDetailsGetGameByIdQueryVariables = {|
  id: string
|};
export type GameDetailsGetGameByIdQueryResponse = {|
  +findGameById: ?{|
    +data: ?{|
      +_id: ?string,
      +name: ?string,
    |}
  |}
|};
export type GameDetailsGetGameByIdQuery = {|
  variables: GameDetailsGetGameByIdQueryVariables,
  response: GameDetailsGetGameByIdQueryResponse,
|};
*/


/*
query GameDetailsGetGameByIdQuery(
  $id: ID!
) {
  findGameById(id: $id) {
    data {
      _id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "findGameById",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "findGameById",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "game",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GameDetailsGetGameByIdQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GameDetailsGetGameByIdQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "GameDetailsGetGameByIdQuery",
    "id": null,
    "text": "query GameDetailsGetGameByIdQuery(\n  $id: ID!\n) {\n  findGameById(id: $id) {\n    data {\n      _id\n      name\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e25bcf96c773d457fa3c6e30e5422210';
module.exports = node;
